import { Flex, FormLabel, Text } from '@chakra-ui/react'
import { QuestionTooltip } from '../QuestionToolTip'

type Props = {
  label?: string
  labelIndexNumber?: number
  helpTooltipText?: string
  isRequired?: boolean
}
export const CommonFormLabel: React.FC<Props> = ({
  label,
  labelIndexNumber,
  helpTooltipText,
  isRequired
}) => {
  return label ? (
    <Flex align="flex-start">
      {labelIndexNumber && (
        <Text
          w="18px"
          h="18px"
          fontSize="11px"
          fontWeight={700}
          borderRadius="full"
          color="white"
          bgColor="primary.black"
          textAlign="center"
          mr="4px"
        >
          {labelIndexNumber}
        </Text>
      )}
      <FormLabel position="relative" minH="18px" h="max-content">
        {label}
        {helpTooltipText && (
          <QuestionTooltip
            position="absolute"
            right={isRequired ? '-60px' : '-24px'}
            top="0px"
            label={helpTooltipText}
          />
        )}
      </FormLabel>
    </Flex>
  ) : null
}
